// extracted by mini-css-extract-plugin
export default {"auxTag":"SponsoredLines_auxTag__shqAK"};